import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * A horizontal line with a label in the middle that separates sections of a page.
 */
@customElement('section-separator')
class SectionSeparator extends LitElement {
  override render() {
    return html`
      <div class=bar></div>
      <div class=text><slot></slot></div>
      <div class=bar></div>
    `;
  }

  static styles = css`
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: var(--sl-spacing-medium) 0;
      margin: var(--sl-spacing-medium) 0;
      margin-bottom: 0;
    }

    .bar {
      border-top: 1px solid var(--sl-color-neutral-300);
      flex: auto;
    }

    .text {
      margin: 0 var(--sl-spacing-medium);
      font-size: var(--sl-font-size-large);
      font-weight: var(--sl-font-weight-semibold);
    }
  `;
}
